import axios from "axios";
import {API_URL} from "../config";

export const storePatientService = async (values) => {
    return axios.post(`${API_URL}/patients`, {...values});
};

export const updatePatientService = async (id, values) => {
    return axios.put(`${API_URL}/patients/${id}`, {...values});
};

export const getPatientService = async (id) => {
    return axios.get(`${API_URL}/patients/${id}`);
}

export const listPatientsService = async (params) => {
    return axios.get(`${API_URL}/patients`, {
        params: {
            ...params
        }
    });
}
